module.exports = __webpack_public_path__ + "img/file-white.1640346b.svg";